import { protectedRequest } from '@/api/protectedRequest'
import http from '@/api/http'
import { mapClientOrderHistoryList } from '@/entities/order/model/mapClientOrderHistory'
import { mapOrder } from '@/entities/order/model/mapOrder'
import { mapOrderPayment } from '@/entities/order/model/mapOrderPayment'

export const CLIENT_ORDER_HISTORY_PAGE_SIZE = 20

export async function createOrderApi(body) {
  const payload = await protectedRequest(() => http.post('/personal/orders', body))
  return payload.data ?? null
}

export async function confirmClientOrderPaymentApi(orderId, { externalId = null } = {}) {
  if (!orderId) {
    return null
  }
  const payload = await protectedRequest(() =>
    http.post(`/personal/orders/${orderId}/confirm-payment`, {
      external_id: externalId,
    }),
  )
  return mapOrderPayment(payload.data ?? null)
}

export async function syncClientOrderPaymentApi(orderId) {
  if (!orderId) {
    return null
  }
  const payload = await protectedRequest(() => http.get(`/personal/orders/${orderId}/payment`))
  return mapOrderPayment(payload.data ?? null)
}

export async function fetchActiveOrderApi() {
  const payload = await protectedRequest(() => http.get('/personal/orders/active'))
  return mapOrder(payload.data ?? null)
}

export async function fetchClientOrderByIdApi(orderId) {
  if (!orderId) {
    return null
  }
  const payload = await protectedRequest(() => http.get(`/personal/orders/${orderId}`))
  return mapOrder(payload.data ?? null)
}

export async function fetchClientOrderHistoryApi({
  limit = CLIENT_ORDER_HISTORY_PAGE_SIZE,
  skip = 0,
} = {}) {
  const payload = await protectedRequest(() =>
    http.get('/personal/orders', {
      params: { limit, skip },
    }),
  )

  const list = mapClientOrderHistoryList(payload.data)
  return {
    items: list,
    total: Number(payload.total) || list.length,
  }
}
